/* tslint:disable */
/* eslint-disable */

/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export * from './BrandEnum';
export * from './Countries';
export * from './DeleteDriverRegistrationDocumentRequest';
export * from './DriverRegistrationLogCreatedVia';
export * from './DriverRegistrationLogFlowType';
export * from './DriverRegistrationLogLastStep';
export * from './DriverRegistrationLogLicenseTypeSelection';
export * from './DriverRegistrationLogResponse';
export * from './DriverRegistrationLogResponseWithCompanyData';
export * from './DriverRegistrationLogSource';
export * from './DriverRegistrationLogStatus';
export * from './DriverRegistrationLogType';
export * from './FleetUploadedDocument';
export * from './FormCityMinimal';
export * from './FormCountryMinimal';
export * from './GetDriverRegistrationMinimalFormDataResponse';
export * from './StandardRequest';
